

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard class='tablewrapper'>
            <CCardHeader>
              <CIcon name="cil-grid"/> 企業管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="2">
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                  <CButton color="info" class="mt-4" @click='showRecordModal({},0, "Create")'>新規作成</CButton>
                </CCol>
              </CRow>
              <div class="row my-2 mx-0">
                <div class="col-sm-6 form-inline p-0">
                  <label class="mr-2">Filter:</label>
                  <input type="text" placeholder="type string..." class="form-control" v-model="searchKeyWord">
                </div>
              </div>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :loading="isLoading"
                :fields="fields"
                :itemsPerPage="20"
                pagination
                class='table-scroll'
              >
                 <template #created_at="{row}">
                  <td class="py-2">
                    {{ formatDate(row) }}
                  </td>
                </template>
                 <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>
                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      v-model="page"
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>

              </CDataTable>

            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">法人名</label>
           <CInput placeholder="法人名" v-model="record.name" :class="{ 'hasError': $v.record.name.$error }"/>

           <small v-if="$v.record.name.$error" class="errorLabel">法人名を入れてください</small>
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">法人番号</label>
           <CInput v-model="record.corporate_number" :class="{ 'hasError': $v.record.corporate_number.$error }" />
           <small v-if="$v.record.name.$error" class="errorLabel">法人番号を入れてください</small>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この法人を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>




  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {Paginate},
  data() {
    return {
      isLoading: false,
      mode: 'Create',
      record: {},
      recordModal: false,
      deleteModal: false,
      itemIndex: 0,
      items: [],
      filter_cs: [],
      filter_vs: [],
      industryTypes: [],
      page: 1,
      word: "",
      sort_column: "id",
      sort_asc: "desc",
      select_gender: '',
      select_status: '',
      meta: {},
      fields: [
        { key: 'id', label: "ID"},
        { key: 'name', label: "法人名"},
        { key: 'corporate_number', label: "法人番号"},
        { key: 'created_at', label: "作成日時"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ],
      memberDic: {"associate_member": "仮登録", "no_deposite_member": "本登録(未入金)", "member": "本登録"},
      searchKeyWord: "",
      isSearching: false,
    }
  },
  validations: {
    record: {
      name: {required},
      corporate_number: {required},
    }
  },
  methods: {
    formatDate: function(d) {
        return moment(d).format("YYYY年MM月DD日 HH:mm")
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規法人追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = i

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.items.splice(this.itemIndex, 1)
        }).catch(error => {
          console.log(error)
        })
    },
    updateItem: function(mode="Create", index=0) {
      // this.$v.record.$touch();
      // if(this.$v.record.$error) return

      if(mode == "Create") {
        console.log(this.record)
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies", {"company": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.push(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies/" + this.record.id, {"company": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.recordModal = false
            this.items[index] = this.record
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    paging: function(n) {
      if(this.isSearching) {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies?&key_word=" + encodeURIComponent(this.word) + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
              this.items = response.data.companies
              this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
              this.items = response.data.companies
              this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      }  
    },

    search: function(key_word) {
      if(key_word != "") {
        this.isSearching = true;
        this.page = 1;
        this.word = key_word
        if(key_word == "-") {
          this.word = ""
        }
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies?&key_word=" + encodeURIComponent(this.word) + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.companies
            this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        this.isSearching = false;
        this.page = 1;
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies", {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.companies
            this.meta = response.data.meta
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }  
    },
  },
  watch: {
    searchKeyWord(newValue) {
      this.search(newValue)
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.items = response.data.companies
        this.meta = response.data.meta
      }).catch(error => {
        this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
<style scoped>
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
.red{
  color: red
}
</style>
